import Link from '@alltrails/denali/components/Link';
import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import styles from '../../../components/OldPressCard/styles/styles.module.scss';
import { OldPressReleaseCard } from '@/components/OldPressCard';

const alltrailsLink = (
  <Link href="/" target="_blank">
    AllTrails
  </Link>
);

const allTrailsDotComLink = (
  <Link href="/" target="_blank">
    AllTrails.com
  </Link>
);

const chatGPTPressRelease: OldPressReleaseCard = {
  cardType: 'press-release',
  title: <FormattedMessage defaultMessage="AllTrails launches AI-powered trail recommendations in debut of OpenAI’s new GPT Store" />,
  date: 'January 10 2024',
  modalContent: (
    <>
      <Typography variant="heading400" component="h2">
        <FormattedMessage defaultMessage="AllTrails launches AI-powered trail recommendations in debut of OpenAI’s new GPT Store" />
      </Typography>
      <Typography variant="paragraph100">
        <FormattedMessage
          defaultMessage="San Francisco. (January 10, 2024) —{alltrailsLink}, the world's largest and most trusted outdoor platform, today launched AllTrails GPT, an AI-powered trail discovery experience on OpenAI’s new GPT Store. The pioneering AllTrails GPT is the latest innovation from the outdoor platform; it builds on AllTrails’ already extensive suite of features that help connect people with the outdoors and elevate their experiences on the trail."
          values={{ alltrailsLink }}
        />
        <br />
        <FormattedMessage defaultMessage="A first of its kind, AllTrails GPT is an interactive experience on the GPT Store. With AllTrails GPT, users can:" />
        <br />
        <ul>
          <li>
            <FormattedMessage defaultMessage="Prompt the GPT by describing their unique needs and obtaining precise and tailored trail information. For example, “Find me a three to five-mile loop trail that is dog-friendly and has great views within 30 miles of San Francisco”" />
          </li>
          <li>
            <FormattedMessage defaultMessage="Receive personalized trail recommendations based on criteria such as location, difficulty level, suitability, length, elevation gain, and points of interest" />
          </li>
          <li>
            <FormattedMessage defaultMessage="Access AllTrails’ global collection of over 420,000 trails" />
          </li>
          <li>
            <FormattedMessage defaultMessage="Find inspiration in trail reviews, ratings, and insights from AllTrails' global community of over 60 million outdoor enthusiasts" />
          </li>
          <li>
            <FormattedMessage defaultMessage="Prepare for outdoor adventures with up-to-date trail information curated by AllTrails’ team of trail data experts" />
          </li>
        </ul>
        <br />
        <FormattedMessage defaultMessage="“As the leading outdoor platform, we’re excited to partner with OpenAI, the leader in AI, to launch in its new GPT Store,” said Ron Schneidermann, Chief Executive Officer at AllTrails. “With AllTrails GPT, we’re combining Open AI’s extremely advanced AI model with AllTrails’ extensive global trail data to deliver personalized recommendations,” he explained. “By leveraging the newest and best technology, we’ve created a fun and innovative way to connect even more people around the world to the outdoors.”" />
        <br />
        <FormattedMessage defaultMessage="AllTrails GPT is available to ChatGPT Plus users via the newly launched GPT Store. It comes shortly after AllTrails was named Apple’s iPhone App of the Year, and is the first of several innovations the brand is unveiling in Q1 2024.  " />
        <br />
        <Typography variant="text100bold">
          <FormattedMessage defaultMessage="About AllTrails" />
        </Typography>
        <br className={styles.noMargin} />
        <FormattedMessage
          defaultMessage="AllTrails helps you find your way outside with detailed reviews and inspiration from a global community of trail-goers. Every day, AllTrails is inspired to help get more people outside so they can have healthy, authentic experiences and a deeper appreciation of the outdoors. AllTrails is Apple’s 2023 iPhone App of the Year and was awarded a Google Play Best of 2023 honorable mention. Download AllTrails in the App Store or head to {allTrailsDotComLink} to learn more."
          values={{ allTrailsDotComLink }}
        />
      </Typography>
    </>
  )
};

export default chatGPTPressRelease;
